import { Tabs } from '@design-systems/canvas-ui'
import { MPMLayout } from 'components/layout/layout'
import { PageTabs } from 'components/page-tabs'
import { TRANSLATION_KEYS } from 'locales/translation-keys'
import { ErrorBoundary } from 'react-error-boundary'
import { ErrorFallback } from 'components/error-fallback'
import { useEffect, useState } from 'react'
import { useEssentials } from 'hooks/utils/useEssentials'
import { useLogClick } from 'utils/analytics'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'

const ROUTES = {
    OVERVIEW: 'overview',
    TARGET_CIRCLE: 'target-circle',
    TARGET_CIRCLE_CARD: 'target-circle-card',
    TARGET_CIRCLE_360: 'target-circle-360',
}

export const LoyaltyPage = () => {
    const { t } = useEssentials()
    const { loyalty } = TRANSLATION_KEYS
    const { tabs: tabsKeys } = loyalty
    const navigate = useNavigate()
    const { pathname, search } = useLocation()

    // we need differentiate tabs (tab.key) and tab translations (tab.label) to ensure
    // our routing stays in english, but our display can switch from english to spanish
    const tabsWithTranslations = [
        { key: ROUTES.OVERVIEW, label: t(tabsKeys.overview) },
        { key: ROUTES.TARGET_CIRCLE, label: t(tabsKeys.targetCircle) },
        {
            key: ROUTES.TARGET_CIRCLE_CARD,
            label: t(tabsKeys.targetCircleCard),
        },
        {
            key: ROUTES.TARGET_CIRCLE_360,
            label: t(tabsKeys.targetCircle360),
        },
    ]

    const { logClick } = useLogClick('loyalty')

    const currentPath = pathname.split('/').pop() || ''

    const getValidActiveTab = (path: string): string => {
        const validRoutes = Object.values(ROUTES)
        return validRoutes.includes(path as any) ? path : ROUTES.OVERVIEW
    }

    const [activeTab, setActiveTab] = useState<string>(
        getValidActiveTab(currentPath),
    )

    useEffect(() => {
        const newPath = pathname.split('/').pop() || ''
        const validTab = getValidActiveTab(newPath)
        setActiveTab(validTab)

        if (newPath && !Object.values(ROUTES).includes(newPath as any)) {
            void navigate(`/loyalty/${ROUTES.OVERVIEW}${search}`, {
                replace: true,
            })
        }
    }, [pathname, navigate, search])

    const handleTabSelect = (activeTab: string) => {
        const path = activeTab
        logClick('loyalty tab ' + activeTab)
        void navigate(`/loyalty/${path}${search}`)
    }
    return (
        <ErrorBoundary
            fallbackRender={({ error, resetErrorBoundary }) => (
                <ErrorFallback
                    error={error}
                    resetErrorBoundary={resetErrorBoundary}
                    heading={t(loyalty.title)}
                />
            )}
        >
            <MPMLayout
                heading={t(loyalty.title)}
                className="hc8-ph-none"
                hasTabs
                tabs={
                    <PageTabs
                        activeTab={activeTab}
                        className="tabs hc8-pv-2x"
                        disableAdaptive={true}
                        onTabSelect={handleTabSelect}
                    >
                        {tabsWithTranslations.map((tab) => (
                            <Tabs.Item key={tab.key} name={tab.key}>
                                {tab.label}
                            </Tabs.Item>
                        ))}
                    </PageTabs>
                }
            >
                <div className="hc8-ph-4x">
                    <Outlet />
                </div>
            </MPMLayout>
        </ErrorBoundary>
    )
}
